import React from "react";

export const PersonalSummarySection = ({ formData }) => (
  <div className="summary-section">
    <h4>Personal Information</h4>
    {formData.title && (
      <div className="summary-row">
        <span className="summary-label">Title:</span>
        <span className="summary-value">{formData.title}</span>
      </div>
    )}
    <div className="summary-row">
      <span className="summary-label">Name:</span>
      <span className="summary-value">
        {formData.firstName} {formData.lastName}
      </span>
    </div>
    <div className="summary-row">
      <span className="summary-label">Email:</span>
      <span className="summary-value">{formData.email}</span>
    </div>
    <div className="summary-row">
      <span className="summary-label">Mobile:</span>
      <span className="summary-value">{formData.mobile}</span>
    </div>
  </div>
);
